import { render } from "./AttachmentFileItem.vue?vue&type=template&id=7b297645&scoped=true&ts=true"
import script from "./AttachmentFileItem.vue?vue&type=script&lang=ts"
export * from "./AttachmentFileItem.vue?vue&type=script&lang=ts"

import "./AttachmentFileItem.vue?vue&type=style&index=0&id=7b297645&scoped=true&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b297645"]])

export default __exports__